import { render, staticRenderFns } from "./Appendix.vue?vue&type=template&id=2f686aac&scoped=true"
var script = {}
import style0 from "./Appendix.vue?vue&type=style&index=0&id=2f686aac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f686aac",
  null
  
)

export default component.exports